import defaultSliderImg from './images/vegetables-140917_640.jpg';
const sliderImages = { defaultSliderImg };

const images = require.context('./images/slider', false, /\.(png|jpe?g|svg)$/);
images.keys().map((item, index) => sliderImages[item.replace('./', '')] = images(item));

export {
    sliderImages
};